import { jsx } from "react/jsx-runtime";
import { PageSection } from "./PageSection.js";
const PageSectionLayout = ({
  layout,
  ctx
}) => {
  if (!layout.as) return /* @__PURE__ */ jsx(PageSection, { ctx, components: layout.components });
  const Cmp = layout.as;
  return /* @__PURE__ */ jsx(Cmp, { className: layout.className, children: /* @__PURE__ */ jsx(PageSection, { ctx, components: layout.components }) });
};
export {
  PageSectionLayout
};
//# sourceMappingURL=PageSectionLayout.js.map
